/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The type of ignore file used.
 */
export const CGIgnoreVersion = /* #__PURE__ */ parsers.exactly('EmptySubmissionFilter', 'IgnoreFilterManager', 'SubmissionValidator');
